module.exports = __webpack_public_path__ + "static/assets/e05995502c7e707680312bdee89027a1.png";